export const selectOpts = (data, label, id_label) => data?.map(x => (
    {
        label: x?.name || x?.display_name || (label ? x[label] : ''),
        value: (id_label ? x[id_label] : undefined) || x?.id
    }))
